import { withErrorBoundary } from 'app/components/error-boundary';
import { withDashboardLayout } from 'app/hooks/with-dashboard-layout';
import type { NavigationScreen } from 'app/types/navigation';
import { withOptionalMetrics } from 'app/utils/performance/with-metrics';
import { MyLoansScreenComponent } from './my-loans-screen-component';
// The dashboard sidebar leaves the planner substantially less room than the window width.

export const MyLoansScreen: NavigationScreen<'my-loans'> = withOptionalMetrics(
  'MyLoansScreen',
  withErrorBoundary(
    withDashboardLayout(MyLoansScreenComponent, 'simpleVerticalScrolling', true, { childrenMaxWidth: 1180 }),
  ),
);
